import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {discardGameInstance} from "../actions/game-instance-actions";
import {listResourcesIfNeeded, invalidateResources, handleApiResponse, types} from "../../../common/crud-actions";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import * as resources from "../actions/resources";
import GameComponent from "./game/game-component";
import GameInstance from "common/models/game-instance";
import {parsePropertiesErrors} from "../../../common/form-helpers";
import {setNotification} from "../actions/notifications-actions";

class Dashboard extends GameComponent {

    componentWillMount() {
        this.props.listResourcesIfNeeded(resources.NAMESPACE_GAME, resources.MODEL_GAME_DEFINITION, {});
    }

    componentDidMount() {
        this.setTitle('Dashboard');
    }

    componentWillUnmount() {
        this.setTitle();
    }

    deleteGameInstance = (instance_id) => {
        let promise = this.props.discardGameInstance(instance_id);
        handleApiResponse(
            resources.MODEL_GAME_INSTANCE,
            'DISCARD',
            promise,
            (result) => {
                this.props.setNotification('success','Hra byla úspěšně smazána.');
            },
            (result) => {
                this.props.setNotification('warning','Nepodařilo se smazat hru.');
            },
            (error) => {
                this.props.setNotification('danger','Vyskytla se neočekávaná chyba.');
            }
        ).then(() => {
            this.props.invalidateResources(resources.MODEL_GAME_DEFINITION);
            this.props.listResourcesIfNeeded(resources.NAMESPACE_GAME, resources.MODEL_GAME_DEFINITION, {});
        })
    };

    render() {
        let canCreateGames = this.props.auth && this.props.auth.type !== 'StudentGroup';

        let activeGames = this.props.game_definitions.list.map((definition) => {
            return (
                <div key={definition.id}>
                    <h4>{definition.name}</h4>
                    { canCreateGames &&
                        <p className='btn-group'>
                            <Link to={{pathname: '/game-new', state: { definition: definition.id }}} className='btn btn-outline-primary'>Nový tým</Link>
                        </p>
                    }
                    <ul id='games-list'>
                        { definition.instances
                            .sort((a, b) => b.id - a.id)
                            .map((instance) => new GameInstance(instance))
                            .map((instance) => (
                            <li key={instance.id}>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-lg-3'>
                                                <div className='label'>Název školy</div>
                                                <p>{ instance.properties.school }</p>
                                            </div>
                                            <div className='col-lg-3'>
                                                <div className='label'>Třída</div>
                                                <p>{ instance.properties.class }</p>
                                            </div>
                                            <div className='col-lg-3'>
                                                <div className='label'>Kapitán</div>
                                                <p>{ instance.properties.captain }</p>
                                            </div>
                                            <div className='col-lg-3'>
                                                <div className='label'>Název týmu</div>
                                                <p>{ instance.data.student_group.username }</p>
                                            </div>
                                        </div>
                                        <div className='label'>Aktuální kolo</div>
                                        <p>{ instance.getCurrentNodeTitle() }</p>
                                        <hr/>
                                        <div className='controls btn-group'>
                                            <Link to={`/game/${instance.id}`} className='btn btn-primary'>Vstoupit</Link>
                                            <Link to={`/game-edit/${instance.id}`} className='btn btn-secondary'><FontAwesomeIcon icon={['far','edit']}/></Link>
                                            <button onClick={() => {
                                                let retVal = confirm("Skutečne chcete smazat tento tým?");
                                                if (retVal === true) this.deleteGameInstance(instance.id);
                                            }} className='btn btn-secondary'><FontAwesomeIcon icon={['far','trash']}/></button>
                                        </div>
                                        <div className='clearfix'/>
                                    </div>
                                </div>
                            </li>
                        )) }
                    </ul>
                </div>);
        });

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        { activeGames }
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        game_definitions: state.game_definitions,
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        discardGameInstance: discardGameInstance,
        listResourcesIfNeeded: listResourcesIfNeeded,
        invalidateResources: invalidateResources,
        setNotification: setNotification
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Dashboard);
